module.exports = __webpack_public_path__ + "img/560.bd314ee5.jpg";